import Quill from 'quill';
import { ImageHandler } from 'ngx-quill-upload';
import QuillImageDropAndPaste from 'quill-image-drop-and-paste';
import { CustomLinkSanitizer } from './quill-link.helper';

export class QuillHelper {
  static init() {
    Quill.register(CustomLinkSanitizer, true);
    Quill.register('modules/imageHandler', ImageHandler);
    Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);
  }
}
